import gql from 'graphql-tag';

// 連携カード番号一覧取得
export const GET_MEMBER_CARD_LIST = gql`
    query(
        $member_no: ID!, $golf_group_code: String!, $begin_row: Int, $limit_rows: Int
    ){
        getMemberCardListMember(
            member_no: $member_no,
            golf_group_code: $golf_group_code,
            begin_row: $begin_row,
            limit_rows: $limit_rows
        ){
            MemberCardList{
                id
                member_no
                golf_group_code
                golf_code
                card_no
                created_at
                updated_at
                golf_name
            }
            count
        }
    },
`;
